import { render, staticRenderFns } from "./NameTag.vue?vue&type=template&id=a6ccac30&"
import script from "./NameTag.vue?vue&type=script&lang=js&"
export * from "./NameTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports